import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Key({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-0.5 -0.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g className={theme.stroke} fill="none" fillRule="evenodd">
        <path d="M30.6036327 10.75945636c-.9734363.99092724-2.5657818 1.00505454-3.5567091.03161819-.9909272-.97343637-1.0050545-2.56645455-.0309454-3.5567091.9734363-.9916 2.5657818-1.00505454 3.5567091-.03161818.9909272.97343637 1.0043818 2.56578182.0309454 3.55670909zm-4.4749818-9.59914545c-6.3323818 0-11.4666364 5.13358182-11.4666364 11.46663639 0 1.6663454.3585637 3.2479272.9976546 4.6761272.0598727.1345455.1217636.2677455.1870182.3996.0524727.1069637.1163818.2072.1722182.3114728l-2.8866728 3.0400545.1210909 2.0027091-1.9926181.1217636-.31483641 2.1587819-3.89374545 4.1258363L5.45776 29.1646018l-2.14667273 2.2744909.12310909 2.0356728-2.16618181.1318545.24016363 3.9536182.02152728.0181636h3.79283636L20.1851055 22.4265655c.2825454.1722181.5704727.3356909.8678181.4830181.0726546.0356546.1459819.0706364.2193091.1056182 1.4752909.6902182 3.1201091 1.0783818 4.8564182 1.0783818 6.3330546 0 11.4666364-5.1342545 11.4666364-11.4666363 0-6.33305457-5.1335818-11.4666364-11.4666364-11.4666364z" />
      </g>
    </svg>
  )
}

Key.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
